import { render, staticRenderFns } from "./Jxjhtx.vue?vue&type=template&id=58aada08&scoped=true"
import script from "./Jxjhtx.vue?vue&type=script&lang=js"
export * from "./Jxjhtx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aada08",
  null
  
)

export default component.exports